import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/Component/Page/CookiePage.jsx");
